import React from 'react'
import toast from 'react-hot-toast'

import InstallApp from '../../../components/InstallApp'
import { useCreateAppMutation } from './happyfox-workflows.service'
import { useAppDetailContext } from '../../AppDetailContext'

const InstallHappyFoxWorkflows = () => {
  const [createApp, createAppResult] = useCreateAppMutation()
  const { name } = useAppDetailContext()

  const handleCreateWorkflow = () => {
    const promise = createApp().unwrap()
    toast.promise(promise, {
      loading: 'Creating HappyFox Workflows integration',
      success: 'HappyFox Workflows integration created successfully',
      error: 'Unable to create HappyFox Workflows integration'
    })
  }

  return <InstallApp name={name} onInstall={handleCreateWorkflow} isInstalling={createAppResult.isLoading} />
}

export default InstallHappyFoxWorkflows
